import * as React from 'react';
import * as UI from 'core/ui';
import { Currency, Math as MathUtils } from 'core/utils';

import { Res } from 'core/api';
import { ActionButtonDefinition, PosStatelessScreenClassComponent, } from 'pos/ui';
import * as Images from 'pos/Images';
import { Flex } from 'core/ui';
import { SuggestedTipAmountModel } from '../../helpers/payments-processing/SuggestedTipAmountModel';
import { Modal } from 'core/ui-next/modal';

type Props = {
	suggestedTipRates: number[],
	totalAmount: number

} & Modal.Actions<SuggestedTipAmountModel>;



export default class SelectSuggestedTipAmountScreen extends PosStatelessScreenClassComponent<Props> {

	protected getScreenId(): string {
		return 'SELECT_SUGGESTED_TIP';
	}

	protected getTitle(): string {
		return Res.Web.SELECT_SUGGESTED_TIP_TITLE();
	}

	protected getImage(): string | SvgIcon {
		return Images.TipSettings;
	}


	protected getScreenSize(): UI.ScreenSize {
		return { width: 375, height: 700 };
	}

	protected useKeypad(): boolean {
		return false;
	}

	protected getActionButtonsDefs(): Nullable<ActionButtonDefinition>[] {
		return [
			this.cancelButton(),
			null,
			null,
			null,
			null,
			null
		];
	}

	onSelectSuggestedTip = async (tipAmount: number): Promise<void> => {
		this.close({ SuggestedTipAmount: tipAmount, IsCustomTipAmount: false });
	};

	onSelectCustomTip = async (): Promise<void> => {
		this.close({ SuggestedTipAmount: 0, IsCustomTipAmount: true });
	};

	getContent(): React.ReactNode {
		return <Flex.Vertical className='text-center p-sm' >
			<Flex.Item className='text-26 font-bold m-b-sm m-t'>{UI.Format.asMoney(this.props.totalAmount)}</Flex.Item>
			<Flex.Item className='text-18 m-b-sm'>{Res.Web.SELECT_SUGGESTED_TIP_ADD_TIP_LBL()}</Flex.Item>
			<Flex.Item size='*' >
				{this.props.suggestedTipRates.map((tipRate) => {
					const tipAmount = MathUtils.round(tipRate * this.props.totalAmount, Currency.DECIMAL_PLACES);
					return <Flex.Item key={tipRate} width='*' className='m-t-md m-b-md'>
						<UI.Button width='*' className='btn-block btn-lg bg-light border-2 text-26 font-bold' tabIndex={-1} onClick={() => this.onSelectSuggestedTip(tipAmount)}>
							{Res.Web.SELECT_SUGGESTED_TIP_RATE_AND_AMOUNT_LBL(UI.Format.asPercentage(tipRate * 100), UI.Format.asMoney(tipAmount))}
						</UI.Button>
					</Flex.Item>;
				})}
			</Flex.Item >
			<Flex.Item className='m-t-sm'>
				<UI.Button width='*' className='btn-block border-2 bg-light font-bold' tabIndex={-1} onClick={this.onSelectCustomTip}>{Res.Web.SELECT_SUGGESTED_TIP_CUSTOM_AMOUNT_LBL()}</UI.Button>
			</Flex.Item>
			<Flex.Item width='*' className='m-t-sm'>
				<UI.Button width='*' className='btn-block border-2 bg-light font-bold' tabIndex={-1} onClick={() => this.onSelectSuggestedTip(0)}>{Res.Web.SELECT_SUGGESTED_TIP_NO_AMOUNT_LBL()}</UI.Button>
			</Flex.Item>
		</Flex.Vertical>;
	}
	onComponentDidMount(): void { }

	onComponentWillUnmount(): void { }
}

